import { render, staticRenderFns } from "./imageDisplay.vue?vue&type=template&id=9cf10ee0&"
import script from "./imageDisplay.vue?vue&type=script&lang=js&"
export * from "./imageDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports